import {DEFAULT_TODO_QUERY, loadTodoStream, resetTodoCriteria} from './actions'

var criteria // shared across actors

function todoCriteriaUpdated() {

    return (state, dispatch) => {
        const nextCriteria = state.workflow.todo.criteria

        if (nextCriteria != criteria) {
            dispatch(loadTodoStream({...DEFAULT_TODO_QUERY, ...nextCriteria}))
            
            criteria = nextCriteria
        }
    }
}

function authenticatedUpdated() {
    var authenticated

    function getActorCriteria(user) {
        if (user) {
            switch(user.userType) {
                case 'patrimonyManager':
                case 'executive':
                case 'callCenterOperator':
                    return [{value: user.userType.charAt(0).toUpperCase() + user.userType.slice(1)}]
                default:
                    return null
            }
        }
    }

    return (state, dispatch) => {
        const nextAuthenticated = state.user.authenticated

        if (nextAuthenticated != authenticated) {
            const nextCriteria = {actor: getActorCriteria(nextAuthenticated)}
            dispatch(resetTodoCriteria(nextCriteria))

            criteria = nextCriteria
            authenticated = nextAuthenticated
        }
    }
}

export default [todoCriteriaUpdated(), authenticatedUpdated()]


// WEBPACK FOOTER //
// ./lib/workflow/actors.js